<template>
  <div>
    <custom-actions>
      <template #header>
      </template>
      <el-form inline :model="searchForm" ref="searchForm" class="global-form-label-width">

        <el-form-item prop="inspectDate" label="巡查日期">
          <!-- <el-date-picker v-model="searchForm.inspectDate" @change="onSearch" placeholder="请选择巡查日期" type="date"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd" :clearable="false">
          </el-date-picker> -->

          <el-date-picker v-model="searchForm.inspectDate" @change="changeDate" type="daterange" format="yyyy-MM-dd"
            value-format="yyyy-MM-dd" :clearable="false" range-separator="-" start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card class="mt10" shadow="never">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column show-overflow-tooltip min-width="120" label="巡查日期" prop="inspectDate">

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="点位总数量" prop="pointNum">

        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="已巡查数量" prop="inspectAllNum"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="已巡查点位数量" prop="inspectNum"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" label="异常点位数量" prop="errorNum"></el-table-column>
        <el-table-column min-width="120" label="操作" prop="errorNum">
          <template v-slot="{ row }">
            <el-button type="text" @click="toDetail(row)">详情</el-button>
          </template>
        </el-table-column>

      </el-table>

      <el-pagination :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
        @current-change="loadData">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>

export default {
  name: 'inspectionRecordStatistics',

  data () {
    return {
      page: 1,
      total: 0,
      tableData: [],
      loading: false,
      searchForm: {
        inspectDate: []
      },

      startDate: '',
      endDate: ''
    }
  },
  computed: {
    pointType () {
      return this.$route.query.pointType // 点位类型1品控2安环
    }
  },
  watch: {
    pointType (val) {
      this.initDate()
      this.resetForm()
    }
  },
  created () {
    this.initDate()
    this.loadData()
  },
  methods: {
    toDetail(row) {
      this.$router.replace('/inspectionRecord/list?pointType=' + this.pointType + '&inspectDate=' + row.inspectDate)
    },
    initDate () {
      this.startDate = this.$dayjs().format('YYYY-MM-DD')
      this.endDate = this.$dayjs().format('YYYY-MM-DD')
      this.searchForm.inspectDate = [this.startDate, this.endDate]
    },
    changeDate (val) {
      this.startDate = val[0] || ''
      this.endDate = val[1] || ''
    },
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.inspectionRecord.selectPaInspectTaskDayByPage, {
        params: {
          page: this.page,
          endDate: this.endDate,
          startDate: this.startDate,
          pointType: this.pointType
        }
      }).then(res => {
        this.tableData = res.list || []
        this.total = res.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch () {
      this.page = 1
      this.loadData()
    },
    resetForm () {
      this.$refs.searchForm.resetFields()
      this.onSearch()
    }

  }
}
</script>

<style scoped lang='scss'>
.btn {
  text-decoration: underline;
  color: #007bff;
  cursor: pointer;
}
</style>
